import { Platform } from "react-native";
import { isic_get_card_microservice } from "../store/api";

export const createFormDataFileFromURI = (uri: string) => {
  const imageURIArr = uri.split(".");
  const extension = imageURIArr[imageURIArr.length - 1];
  const imageName = Date.now() + "." + extension;
  const file = {
    name: imageName,
    uri: Platform.OS === "ios" ? uri.replace("file://", "") : uri,
    type: "image/" + extension,
  };
  return file as any;
};

export const getUserImageURI = (imageId: string) =>
  isResolvedImageSource(imageId)
    ? imageId
    : `${isic_get_card_microservice}/users/profile/image/${imageId}`;

/**
 * True when a value is already something an <Image> can render, rather than an
 * opaque image id that must be fetched from the image microservice. Covers data
 * URIs, absolute URLs, blob/file URIs and bundled asset paths such as
 * "/static/media/photo.abc123.jpg" produced by the web build.
 */
export const isResolvedImageSource = (value?: string): boolean =>
  typeof value === "string" &&
  (value.startsWith("data:") ||
    value.startsWith("http://") ||
    value.startsWith("https://") ||
    value.startsWith("blob:") ||
    value.startsWith("file:") ||
    value.startsWith("/"));
